"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSupportingDocumentationLinks = exports.parsePreviewEvidences = exports.parseEvidences = void 0;
const constants_1 = require("../../constants/constants");
const axiosConfig_1 = require("../axios/axiosConfig");
const parseEvidences = (credential_no) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield (0, axiosConfig_1.getAxiosInstance)().post(constants_1.EvidenceRoutes.parseEvidences(), {
            credential_no,
        });
        return response.data;
    }
    catch (error) {
        console.log(error);
        return [];
    }
});
exports.parseEvidences = parseEvidences;
const parsePreviewEvidences = (deliveryId) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield (0, axiosConfig_1.getAxiosInstance)().post(constants_1.EvidenceRoutes.parsePreviewEvidences(), {
            deliveryId,
        });
        return response.data;
    }
    catch (error) {
        console.log(error);
        return [];
    }
});
exports.parsePreviewEvidences = parsePreviewEvidences;
const parseSupportingDocumentationLinks = (credential_no) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        let response = yield (0, axiosConfig_1.getAxiosInstance)().post(constants_1.EvidenceRoutes.parseSupportingDocumentationLinks(), {
            credential_no,
        });
        return response.data.result;
    }
    catch (error) {
        console.log(error);
        return [];
    }
});
exports.parseSupportingDocumentationLinks = parseSupportingDocumentationLinks;
